import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.D3idYv',
    defaultMessage: 'Settings',
  },
  user: {
    id: 'studio.EwRIOm',
    defaultMessage: 'User',
  },
  socialLogin: {
    id: 'studio.TUggpX',
    defaultMessage: 'Social login',
  },
  connectedApps: {
    id: 'studio.a0k4/v',
    defaultMessage: 'Connected apps',
  },
  organizations: {
    id: 'studio.JD2pwH',
    defaultMessage: 'Organizations',
  },
  clientCredentials: {
    id: 'studio.pysIuq',
    defaultMessage: 'Client credentials',
  },
});
